import AuthProvider from '@/services/auth.provider'
import Vue from 'vue'

const authService = new AuthProvider()

const initialState = {
    user: null,
    login_status: false,
    sidebar_status: null,

    is_authen: null,
    is_error: false,
};

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        async getUserInfo({ commit, dispatch }) {
            const uid = localStorage.getItem('uid');
            const data = await authService.getUserInfo(uid).catch((error) => {
                this.state.auth.is_error = true;
                Vue.toasted.error(
                    JSON.stringify(error.response.data.message),
                    { duration: 0 }
                )
                if (error.response.data.message === 'Expired token') { // Token Expired
                    localStorage.clear();
                    window.location.reload();
                }
            });

            if (data) {
                // เช็ค privilege ว่าสามารถใช้งานระบบได้
                if (!data.admission.status && !data.delegated_officer.status) {
                    this.state.auth.is_error = true;
                    Vue.toasted.error(
                        'ไม่มีสิทธิ์ใช้งานระบบ / Unauthorized',
                        { duration: 0 }
                    )
                    return;
                }

                commit('set_user', data);
                commit('set_login_status', true);
                if (data.admission.status) {
                    dispatch('getSidebarStatus');
                }

                this.state.auth.is_authen = true;
            }
        },

        logout({ dispatch }) {
            localStorage.clear();
            dispatch('keycloak/logout', null, { root: true });
        },

        logoutDelegatedUser() {
            localStorage.removeItem('token');
            localStorage.removeItem('uid');
            window.location.reload();
        },

        async getSidebarStatus({ commit }) {
            const uid = localStorage.getItem('uid');
            const data = await authService.getSidebarStatus(uid);
            commit('set_sidebar_status', data);
        },
    },
    mutations: {
        set_user(state, data) { state.user = data },
        set_login_status(state, data) { state.login_status = data },
        set_sidebar_status(state, data) { state.sidebar_status = data },

        setIsAuthen(state, is_authen) {
            state.is_authen = is_authen;
        }
    },
};